import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin:undefined 
  },
  getters:{
    isLogin: state => {
      console.log('isLogin-init',state.isLogin)
      if (!state.isLogin) {
        state.isLogin =  localStorage.getItem('isLogin')
      }
      return state.isLogin
    },
  },
  mutations:{

    setLogin (state, isLogin) {
      console.log('isLogin',isLogin)
      state.isLogin = isLogin
      localStorage.setItem('isLogin', isLogin)
    },
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js